module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_xv"
    }
  }), _c('a', {
    attrs: {
      "id": "ack"
    }
  }), _vm._v("Acknowledgments")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("We would like to thank Michael Gazzaniga at the Sage Center for the Study of the Mind at the University of California–Santa Barbara for hosting the conference in February 2009 which served as the foundation for this book project. We are very grateful for his support. We also thank those additional participants whose contributions greatly enriched the conference, and whose ideas infuse this volume, especially Leda Cosmides, John Tooby, Sarah Medland, Allan Stam, and Anthony Lopez. In addition, we would like to thank David Pervin at the University of Chicago Press for his tireless and insightful efforts in support of this volume. And we are grateful to Therese Boyd for her careful copyediting of the entire manuscript. All errors remain our own."), _c('a', {
    attrs: {
      "id": "page_xvi"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b0537f64","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/9780226319094_07_ack.vue
// module id = 75
// module chunks = 0